import React, { useCallback, useEffect, useState } from 'react';
import SoloShell from './SoloShell';
import { api } from './api';
import './BuzzerSolo.css';

export default function BuzzerSoloTeamPage() {
  const [payload, setPayload] = useState({ users: [], areas: [] });
  const [message, setMessage] = useState('');

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/buzzersolo/team');
      setPayload(data || { users: [], areas: [] });
    } catch (error) {
      setMessage(error?.response?.data?.error || 'Failed to load team');
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggleArea = async (userId, areaId, currentAreaIds) => {
    const next = currentAreaIds.includes(areaId)
      ? currentAreaIds.filter((id) => id !== areaId)
      : [...currentAreaIds, areaId];
    try {
      await api.post(`/buzzersolo/team/${userId}/areas`, { areaIds: next });
      setMessage('Permissions updated.');
      await load();
    } catch (error) {
      setMessage(error?.response?.data?.error || 'Failed to update permissions');
    }
  };

  return (
    <SoloShell title="Team & Area Permissions" subtitle="Managers see all areas. Service staff receive only the Solo notifications for their assigned areas.">
      {message ? <div className="bsolo-card" style={{ marginBottom: 16 }}>{message}</div> : null}
      <div className="bsolo-list">
        {payload.users.map((user) => (
          <div key={user.id} className="bsolo-panel">
            <div className="bsolo-row" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <strong>{user.name || user.username}</strong>
                <div className="bsolo-meta">{user.email || user.username}</div>
              </div>
              <div className="bsolo-meta">
                {user.view_admin ? 'Admin' : user.at_service ? 'Service' : 'Other'} • {user.push_notifications ? 'Push on' : 'Push off'}
              </div>
            </div>

            {!user.view_admin && (
              <div className="bsolo-checklist" style={{ marginTop: 14 }}>
                {payload.areas.map((area) => (
                  <label key={area.id} className="bsolo-check">
                    <input
                      type="checkbox"
                      checked={user.areaIds.includes(area.id)}
                      onChange={() => toggleArea(user.id, area.id, user.areaIds)}
                    />
                    <span>{area.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </SoloShell>
  );
}
